import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function UsaPage() {
  return <CountryPageTemplate country={countryPages.usa} />;
}

export default UsaPage;
